import { useEffect } from "react";

type Props = {
  id: string;
  value: string;
  isDisabled?: boolean;
  type?: string;
};

export default function useScriptFunction({
  id,
  value,
  isDisabled = false,
  type,
}: Props) {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (document.getElementById(id)) return;
    if (isDisabled) return;

    const script = document.createElement("script");

    if (type) {
      script.type = type;
    }
    script.innerHTML = value;
    script.id = id;

    document.head.appendChild(script);
  }, [id, value, isDisabled, type]);
}
